/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { inject } from "mobx-react";
import FAB from "components/FAB/FAB";
import { getFABComponent, getFABVerbId, getFABVisibility } from "../../selectors/fabSelectors";
import { getBottomPanelHeight } from "../../selectors/documentSelectors";

const mapStoreToProps = (stores, ownProps) => ({
  ...ownProps,
  FABVerbId: getFABVerbId(stores),
  FABVisibility: getFABVisibility(stores),
  bottomOffset: getBottomPanelHeight(stores),
  setFABVisibility: stores.FABStore.setFABVisibility,
  FABComponent: getFABComponent(stores)
});

const FABContainer = inject(mapStoreToProps)(FAB);

export default FABContainer;
